import { useIntl } from 'react-intl';
import { selectSalesmanInfo } from '../../../../../store/selectors';
import { useSelector } from 'react-redux';
import { COMPLETED } from '../../../../../store/actions/types';

const Contact = () => {
  const { formatMessage } = useIntl();
  const { data, status } = useSelector(selectSalesmanInfo);
  const { firstName, lastName, phoneNumber, email } = data || {};
  const isDataLoaded = status === COMPLETED;

  return (
    isDataLoaded && (
      <div className='integration__contact'>
        <h4 className='integration__contact--headline'>{formatMessage({ id: 'Business contact' })}</h4>
        <p className='integration__contact--name'>
          {firstName} {lastName}
        </p>
        <p className='integration__contact--phone'>{phoneNumber}</p>
        <p className='integration__contact--email'>{email}</p>
      </div>
    )
  );
};

export default Contact;
